import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils/cn';

interface ErrorMessageProps {
  message?: string;
  className?: string;
  onRetry?: () => void;
}

export function ErrorMessage({
  message,
  className,
  onRetry,
}: ErrorMessageProps) {
  const { t } = useTranslation();
  const displayMessage = message ?? t('common.error');
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-lg border border-red-200 bg-red-50 p-6',
        className,
      )}
    >
      <svg
        className="mb-4 h-12 w-12 text-red-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        />
      </svg>
      <p className="text-center text-gray-700">{displayMessage}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-4 rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
        >
          {t('common.retry')}
        </button>
      )}
    </div>
  );
}
